import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface LayoutState {
	pageButtons: PageButton[];
	pageTitle: string | JSX.Element;
	internetStatus: number;
	drawerOpen: boolean;
	updateAvailable: boolean;
	playAlarm: boolean;
}

const initialState: LayoutState = {
	pageButtons: [],
	pageTitle: "Count",
	internetStatus: 0,
	drawerOpen: false,
	updateAvailable: false,
	playAlarm: false,
};

export const layoutSlice = createSlice({
	name: "material",
	initialState,
	reducers: {
		openDrawer: (state) => {
			state.drawerOpen = true;
		},
		closeDrawer: (state) => {
			state.drawerOpen = false;
		},
		appUpdateAvailable: (state) => {
			state.updateAvailable = true;
		},
		appUpdateNotAvailable: (state) => {
			state.updateAvailable = false;
		},
		startAlarm: (state) => {
			state.playAlarm = true;
		},
		stopAlarm: (state) => {
			state.playAlarm = false;
		},
		updatePageTitle: (state, action: PayloadAction<string | JSX.Element>) => {
			state.pageTitle = action.payload;
		},
		updatePageButtons: (state, action: PayloadAction<PageButton[]>) => {
			state.pageButtons = action.payload;
		},
		updateInternetStatus: (state, action: PayloadAction<number>) => {
			state.internetStatus = action.payload;
		},
	},
});

export const {
	updatePageButtons,
	updateInternetStatus,
	updatePageTitle,
	appUpdateAvailable,
	appUpdateNotAvailable,
	openDrawer,
	closeDrawer,
	startAlarm,
	stopAlarm,
} = layoutSlice.actions;

export default layoutSlice.reducer;
